// AbMapJsonTab — Experten-Modus: Textarea synchron zum Formular. Nicht-'unsupported'-Regelsets
// sind hier NUR LESBAR (Quelle der Wahrheit ist das Formular); 'unsupported'-Regelsets (Formular
// kann sie nicht abbilden, s. rulesetModel.js#markUnsupported) sind hier direkt editierbar.

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { inputCls } from '../components/ui';

const AbMapJsonTab = ({ isDarkMode, t, json, unsupported, onChangeRawJson, jsonError }) => {
  const textMuted = isDarkMode ? 'text-white/55' : 'text-slate-500';
  return (
    <section className="space-y-2">
      <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white/80' : 'text-slate-700'}`}>{t('ab.map.jsonExpertTitle')}</h3>
      <textarea
        value={json}
        readOnly={!unsupported}
        spellCheck={false}
        onChange={(e) => { if (unsupported) onChangeRawJson(e.target.value); }}
        rows={22}
        className={`${inputCls(isDarkMode)} w-full font-mono text-xs resize-y ${!unsupported ? 'opacity-90 cursor-default' : ''}`}
      />
      {jsonError && (
        <p className={`text-xs flex items-center gap-1.5 ${isDarkMode ? 'text-red-300' : 'text-red-600'}`}>
          <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />{t('ab.map.jsonInvalid', { error: jsonError })}
        </p>
      )}
      <p className={`text-xs ${textMuted}`}>{unsupported ? t('ab.map.jsonUnsupportedHint') : t('ab.map.jsonReadOnlyHint')}</p>
    </section>
  );
};

export default AbMapJsonTab;
